<template>
<div>
    <nav class="navbar navbar-default navbar-fixed-top">
        <div class="nav-bg">
            <div class="nav_bar" @click="flag=flag==false?true:false">
              <span></span>
              <span></span>
              <span></span>
            </div>
        </div>
        <div class="container">
            <div id="navbar" class="text-center">
                <ul class="nav navbar-nav navbar-right nav-menu-user">
                    <li class="warp-userinfo-header" >
                        <span class="iconfont icon-user ico-user" @click="userFlag = !userFlag"></span>
                        <div class="expand-nav-content-userinfo">
                            <span>{{userName}} &nbsp;|&nbsp; <a @click="logout">Logout</a></span></div>
                    </li>
                </ul>
            </div>
            <div v-show="loading">
              <img v-if="$isAis" src="../assets/img/header/img_logo_ais_fibre.png" title="logo" class="logo-ais" @click="toHome"/>
              <img v-else-if="isTOT" src="@/assets/img/login/tot.png" title="logo" class="logo-ais" @click="toHome"/>
              <img v-else src="../assets/img/header/logo.png" title="logo" class="logo-ais" @click="toHome"/>
            </div>
            
        </div>
        <div class="toggle" v-show="userFlag">
            <div class="user">
                <span>{{userName}} &nbsp;|&nbsp; <a @click="logout">Logout</a></span>
            </div>
        </div>
    </nav>
    
        <mobileNev v-bind:visible="flag" @changeNev="changeNev"  @close="close" ref="mobile"></mobileNev>
    </div>
</template>

<script>
import mobileNev from './mobileNav'
import _logout from '@/util/logout'
import devConfig from '@/devConfig'
export default {
  components:{mobileNev},
  data() {
    return {
      flag:false,
      userFlag: false,
      searchFlag: false,
      userName: cookie.getItem("username") || "admin",
      isTOT:false,
      loading:false,
    };
  },
  created(){
       devConfig.init(this, () => {
          this.isTOT = devConfig.getData().area === 'TOT'
          this.loading = true
       })
  },
  methods: {
    close(flag){
      this.flag=flag;
    },
    logout() {
      _logout()
    },
    menuChange(e) {
      if (window.screen.width <= 768) {
        if (e.target.nodeName == "I") {
          if (this.searchFlag == false) {
            this.userFlag = false;
            this.searchFlag = true;
          } else {
            this.userFlag = false;
            this.searchFlag = false;
          }
        } else {
          if (this.userFlag == false) {
            this.userFlag = true;
            this.searchFlag = false;
          } else {
            this.userFlag = false;
            this.searchFlag = false;
          }
        }
      }
    },
    toHome(){
        this.$router.push('home')
    },
    changeNev(index,index1){
      this.$emit("changeNev",index,index1);
    }
  }
};
</script>

<style src="@/assets/style/bootstrap.css"></style>
<style src="@/assets/style/header.scss" lang="scss"></style>
<style scoped>
.logo-ais{
    left: 60px;
    cursor:pointer;
    width: 150px;
    height: 50px;
}
@media (max-width: 768px){
    .logo-ais{
        left: calc(50% - 67px);
    }
}
</style>



